
const initialState = [];
export const termsPrivacyHistory = (state = initialState, action) => {
    switch (action.type) {
        case 'TERMS_PRIVACY_HISTORY_DATA':
            return action.payload;
        default:
            return state;
    }
};